
import Skeleton from '@/components/skeleton/index.vue'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import PhotoUpload from '@/components/avatar_upload/index.vue'
import UploadImg from '@/common/class/UploadImg'
import { Component, Vue } from 'vue-property-decorator'
// eslint-disable-next-line
import { ElForm } from 'element-ui/types/form'
import { isString } from 'lodash'
import { WinpressService } from '@/services'
import { IMG_HOST } from '@/config/env'

@Component({
    name: '',
    components: {
        CreateDetailLayout,
        Skeleton,
        PhotoUpload
    }
})
export default class extends Vue {
    private createLoading = false
    private form = {
        name: '',
        icon: ''
    }
    private rules = {
        name: [{ required: true, message: '请输入分类名称' }],
        icon: [{ required: true, validator: this.iconValidator, trigger: 'none' }]
    }
    private file!: any

    created() {
        this.file = null
        this.$title('创建文章分类 | 麦媒云 - 庖丁')
    }
    iconValidator(rule: any, value: any, callback: Function) {
        if (!this.file) {
            callback(new Error('请选择图标'))
        }
        callback()
    }
    onPhotoChange() {
        this.file = (this.$refs.photoRef as any).getFile()
    }
    onCreate() {
        (this.$refs.form as ElForm).validate(async isValid => {
            if (!isValid) return
            if (isString(this.file)) {
                this.form.icon = this.file
            } else {
                // 上传图片
                const result = await new UploadImg(this.file).upload()
                if (result.error) {
                    return this.$merror('图片上传失败，请稍后再试')
                }
                this.form.icon = IMG_HOST + result.key as string
            }
            this.createLoading = true
            await this.createArticleType()
            this.createLoading = false
        })
    }
    async createArticleType() {
        const params = { ...this.form }
        const result = await WinpressService.createArticleType(params)
        if (result.status === 200) {
            (this.$refs.form as ElForm).resetFields()
            ;(this.$refs.photoRef as any).reset()
            return this.$msuccess('创建成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
}
